module.exports = __webpack_public_path__ + "static/media/notification-svgrepo-com (6).aa53e911.svg";